/* eslint-disable @typescript-eslint/no-explicit-any */
import { hcpAPI } from 'configs/axios';

export const saveChartData = (data: any) => {
  return hcpAPI({ url: '/processed_data/manual_edit', method: 'POST', data });
};

export const checkReportSavingStatus = (hash: any, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/processed_data/manual_edit/poll/${hash}`,
    method: 'GET',
    config: { signal },
  });
};

export const fetchRecordRawData = (id: string, signal?: AbortSignal | undefined) => {
  return hcpAPI({
    url: `/processed_data/content?recording_id=${id}`,
    method: 'GET',
    config: { signal },
  });
};
